import UnifiedTimeline from "../../shared/Timeline/UnifiedTimeline";

/** @deprecated Use UnifiedTimeline. Thin wrapper for investment staff detail. */
export default function InvestorPortalTimeline({ items = [] }) {
  return <UnifiedTimeline items={items} showActor emptyMessage="No timeline events yet." />;
}
